import request from "@/utils/request";

// 获取作品列表
export function getList(data) {
    return request({
        url: "/match/item/list_user",
        method: "post",
        data
    });
}

// 获取个人信息
export function getUserInfo(params) {
    return request({
        url: "user/user/userVoInfo",
        method: "get",
    });
} 

// 修改个人信息
export function updatUserInfo(data) {
    return request({
        url: "user/user/updateUserInfo",
        method: "post",
        data
    });
}

// 删除个人信息
export function deleUserInfo(data) {
    return request({
        url: "/match/item/delete",
        method: "post",
        data
    });
}

// 修改密码
export function updatePassword(data) {
    return request({
        url: "user/user/updatePassword",
        method: "post",
        data
    });
}

//查询是否可以报名
export function searchApplyByUser(data) {
    return request({
        url: "/match/user/apply/searchApplyByUser",
        method: "post",
        data
    });
}
//报名
export function apply(data) {
    return request({
        url: "/match/user/apply/apply",
        method: "post",
        data
    });
}
//取消报名
export function disApply(data) {
    return request({
        url: "/match/user/apply/disApply",
        method: "post",
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/mywork.js